export default {
  "@global": {
    ".tippy-popper": {
      fontFamily: "arial, sans-serif",
    },
    ".tippy-tooltip": {
      padding: "1rem 0.5625rem",
      borderRadius: "3px",
      textAlign: "left",
    },
    ".tippy-content img": {
      width: "100%",
    },
  },
  container: {},
};
